import { useCallback } from 'react';
import { toast } from 'react-toastify';

const useMapSaveHandler = ({
  mode,
  selectedLocation,
  polygonData,
  onLocationSelect,
  closeModal
}) => {
  return useCallback(() => {
    if (mode === 'location' && selectedLocation) {
      onLocationSelect({
        type: 'location',
        data: { ...selectedLocation }
      });
    } else if (mode === 'polygon' && polygonData) {
      onLocationSelect({
        type: 'polygon',
        data: polygonData
      });
      toast.success('Farmland mapped successfully');
    }
    closeModal();
  }, [mode, selectedLocation, polygonData, onLocationSelect, closeModal]);
};

export default useMapSaveHandler;
